import { Button } from "@mui/material";

const ButtonReject = ({
  invitation_id,
  setRefresh,
  label = "Reject",
  onClick = async () => {
    await request(invitation_id);
    setRefresh((r) => !r);
  },
  request,
}) => {
  return (
    <Button
      onClick={onClick}
      sx={{
        textTransform: "none",
        fontFamily: "Poppins",
        fontWeight: 200,
        color: "#c62828",
        borderRadius: 1,
        "&:hover": {
          color: "#b71c1c",
          backgroundColor: "#ffcdd2",
          fontWeight: 500,
        },
        "&.MuiButtonBase-root": {
          paddingY: 0.2,
        },
      }}>
      {label}
    </Button>
  );
};
export default ButtonReject;
